import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';
import { jobOffer } from 'job/model/job-offer.fragments';
import { tasksParticipant } from 'task/model/task.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { TaskOutput } from '../model/task.output';

export interface CreateCoachMeetingInput {
	readonly coacheesId: string[];
	readonly dueTimestamp: number;
	readonly modulesId: string[];
	readonly canCoacheesBeNotified: boolean;
}

export interface CreateCoachMeetingParams {
	input: CreateCoachMeetingInput;
}

@Injectable({ providedIn: 'root' })
export class CreateCoachMeetingApiMutation extends ApiMutation<
	TaskOutput,
	CreateCoachMeetingParams
> {
	client = 'iam';
	document = gql`
		mutation CreateCoachMeeting($input: CreateCoachMeetingInput!) {
			createCoachMeeting(input: $input) {
				id
				done
				type
				owner {
					id
				}
				contact {
					...Contact
				}
				jobOffer {
					...JobOffer
				}
				modulesId
				todoTitle
				dueTimestamp
				updateTimestamp
				participants {
					...TasksParticipant
				}
				todoDescription
			}
		}
		${tasksParticipant}
		${jobOffer}
		${contact}
	`;
	method = 'createCoachMeeting';
}
